import { AlertTriangle } from 'lucide-react';

import { formatarDataHora } from '@/nucleo/formato/datas';

import type { Veiculo } from './contrato';

/**
 * Aviso de que a capacidade total foi lançada à mão e difere do último valor
 * oficial do SGTP — o `CapacidadeDivergenteAlert` do protótipo, na variante
 * do portal: só leitura, sem "Sincronizar agora" (quem sincroniza é a
 * operação).
 *
 * Só aparece com origem `MANUAL`, leitura do SGTP existente e valores
 * diferentes. Nos outros casos não há o que avisar, e o componente some.
 */
export function CapacidadeDivergenteAlert({
  veiculo,
}: {
  veiculo: Pick<
    Veiculo,
    | 'capacidade_total_origem'
    | 'capacidade_total'
    | 'capacidade_sgtp_snapshot'
    | 'ultima_consulta_sgtp_capacidade'
  >;
}) {
  const {
    capacidade_total_origem: origem,
    capacidade_total: total,
    capacidade_sgtp_snapshot: oficial,
    ultima_consulta_sgtp_capacidade: ultimaConsulta,
  } = veiculo;

  if (origem !== 'MANUAL' || oficial == null || total == null || oficial === total) {
    return null;
  }

  return (
    <div
      role="status"
      className="flex items-start gap-2 rounded-md border border-warning/30 bg-warning/10 px-3 py-2 text-sm text-foreground"
    >
      <AlertTriangle className="mt-0.5 h-4 w-4 shrink-0 text-warning" aria-hidden="true" />
      <div className="leading-snug">
        <strong className="font-medium">Capacidade manual difere do SGTP</strong> ({oficial} lugares
        oficiais).
        {ultimaConsulta && (
          <span className="block text-xs text-muted-foreground">
            Última consulta: {formatarDataHora(ultimaConsulta)}
          </span>
        )}
      </div>
    </div>
  );
}
